import { useFactorLensContext, useViewedFactorType } from '@/contexts/FactorLensContext/hooks'
import { useTheme } from '@/contexts/RADashboardThemeContext/hooks'
import { FactorLensDataType } from '@/interfaces/factorLens.interface'
import { buttonGroupDeselectedStyle, buttonGroupSelectedStyle } from '@/styles/reportDashboardStyles'
import { Button } from '@mui/material'
import React from 'react'

const DATA_TYPE_OPTIONS = Object.values(FactorLensDataType)

/**
 * Portfolio / Benchmark / Active selector for the Factor Lens cards. Reads and
 * writes the shared data type via context, so every Factor Lens card stays in sync.
 */
const FactorDataTypeSelector: React.FC = () => {
  const theme = useTheme()
  const { setDataType } = useFactorLensContext()
  const selectedDataType = useViewedFactorType()

  const getButtonStyle = (option: FactorLensDataType) => {
    let stateStyle = {
      ...buttonGroupDeselectedStyle,
      color: theme.textPrimary,
    }

    if (option === selectedDataType) {
      stateStyle = {
        ...buttonGroupSelectedStyle,
        backgroundColor: theme.tabSelectedBackground,
        color: theme.textPrimary,
      }
    }

    return { ...{ flex: 1 }, ...stateStyle }
  }

  return (
    <div style={{ width: '100%', alignContent: 'center', justifyItems: 'center' }}>
      <div style={{ display: 'flex', width: '100%', borderRadius: '8px', backgroundColor: theme.tabBackground }}>
        {DATA_TYPE_OPTIONS.map((option) => (
          <Button key={option} style={getButtonStyle(option)} onClick={() => setDataType(option)}>
            {`${option} Risk`}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default FactorDataTypeSelector
